import { ResetPasswordErrorCodes } from "./constants";

export const formatSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

  return `${minutes}:${formattedSeconds}`;
};

export const phraseErrorMessage = (errorCode, secondsLeft) => {
  if (
    errorCode ===
      ResetPasswordErrorCodes.PASSWORD_RESET_ATTEMPT_LIMIT_REACHED &&
    secondsLeft
  ) {
    return `An email has already been sent to you from the TradeAlgo team. Please wait ${formatSeconds(secondsLeft)} before requesting another one.`;
  }
  return "An error has occurred. Please try again.";
};
